import { Expose, Type } from 'class-transformer';
import { SurveyElementsUnion } from './survey-elements-union';
import { SurveyElement } from '@/models/survey-elements';
import { DiscriminatorConfig } from '@/models/survey-elements/survey-element-discriminator';

type NextViewElement = {
  type: string;
  text: string;
};
export class Elements {
  @Type(() => SurveyElement, {
    discriminator: {
      property: 'element_type',
      subTypes: DiscriminatorConfig(),
    },
    keepDiscriminatorProperty: true,
  })
  elements!: SurveyElementsUnion[];
  @Expose({ name: 'next_view_element' })
  nextViewElement?: NextViewElement;
}

export class Survey {
  @Expose()
  id!: string;

  @Expose({ name: 'is_next_view' })
  isNextView!: boolean;

  @Expose({ name: 'is_next_view_button_visible' })
  showSubmitButton!: boolean;

  @Expose({ name: 'active_view' })
  @Type(() => Elements)
  activeView!: Elements;

  @Expose({ name: 'active_branch_identifier' })
  activeBranchIdentifier!: string;

  @Expose({ name: 'active_view_name' })
  activeViewName!: string | null;
}
